// takes a string with thousands separated by commas and decimals and returns number or NaN
export const parseNumber = (str: string) => {
  const cleanedStr = str.replace(/[$,]/g, "");
  const number = parseFloat(cleanedStr);
  return isNaN(number) || !isFinite(number) ? NaN : number;
};
